import React from 'react';
import { Menu } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/collections/menu.less';

export default Menu;
